import React, { Component } from 'react';

import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeNotificationPreferences extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeNotificationPreferences = (preferences) => {

    if (!preferences) {
      return null;
    }

    return <div className="standard-container">
      <Header title='Practice Notifications'
              icon='fas fa-bell'
              button_title='Edit Preferences'
              button_action={ () => {
                this.props.practiceActions.openPracticeNotificationPreferences();
              }} />
      <div className="flex-container flex-container-column" style={{ padding: 15, paddingTop: 15 }}>
        <span style={{ fontSize: 13, color: 'grey' }}>Customize the way you and your team receive notifications.</span>
      </div>
    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.renderPracticeNotificationPreferences(this.props.preferences);
  }

}


export default PracticeNotificationPreferences
